import { render } from "./Abn.vue?vue&type=template&id=46abddc6"
import script from "./Abn.vue?vue&type=script&lang=js"
export * from "./Abn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__